<div class="flex flex-row lt-lg:flex-col gap-[24px] xs:gap-[16px] justify-start items-start">
  <div class="xs:flex xs:flex-col xs:gap-[16px] gt-md:flex-[65%] gt-md:max-w-[65%] lt-lg:flex-1">
    <app-feature-list-container class="flex flex-col gap-[24px] xs:gap-[16px]">
      <div class="commissioning-subtitle">
        1. {{ '+GATEWAY_COMMISSIONING_REDESIGN.INSTRUCTIONS_TITLE' | translate }}
      </div>
      <div class="flex flex-row lt-md:flex-col gap-[24px] xs:gap-[16px] justify-start items-start">
        <div class="commissioning-description flex-[100%] gt-xs:max-w-[50%]">
          {{ '+GATEWAY_COMMISSIONING_REDESIGN.INSTRUCTION_DESCRIPTION' | translate }}
        </div>
        <div class="instructions flex-1">
          <div class="instruction-option">
            <div class="order">1.1</div>
            <div>{{ '+GATEWAY_COMMISSIONING_REDESIGN.INSTRUCTIONS_OPTION1' | translate }}</div>
          </div>
          <div class="instruction-option">
            <div class="order">1.2</div>
            <div>{{ '+GATEWAY_COMMISSIONING_REDESIGN.INSTRUCTIONS_OPTION2' | translate }}</div>
          </div>
          <div class="instruction-option">
            <div class="order">1.3</div>
            <div>{{ '+GATEWAY_COMMISSIONING_REDESIGN.INSTRUCTIONS_OPTION3' | translate }}</div>
          </div>
          <div class="instruction-option">
            <div class="order">1.4</div>
            <div>{{ '+GATEWAY_COMMISSIONING_REDESIGN.INSTRUCTIONS_OPTION4' | translate }}</div>
          </div>
        </div>
      </div>
    </app-feature-list-container>

    <app-feature-list-container class="flex flex-col gap-[24px] xs:gap-[16px]">
      <div class="commissioning-subtitle">
        2. {{ '+GATEWAY_COMMISSIONING_REDESIGN.WIFI_INSTRUCTIONS_TITLE' | translate }}
      </div>
      <div class="flex flex-row lt-md:flex-col gap-[24px] xs:gap-[16px] justify-start items-start">
        <div class="commissioning-description flex-[100%] gt-xs:max-w-[50%]">
          {{ '+GATEWAY_COMMISSIONING_REDESIGN.WIFI_INSTRUCTIONS_TITLE_DESCRIPTION' | translate }}
        </div>
        <div class="instructions flex-1">
          <div class="instruction-option flex flex-col gap-[16px] justify-start items-start">
            <div class="order">2.1</div>
            <div>{{ '+GATEWAY_COMMISSIONING_REDESIGN.WIFI_INSTRUCTIONS_OPTION1' | translate }}</div>
            <button
              mat-button
              gtm="onGoToPage"
              gtmAction="Vitoconnect gateway"
              gtmCategory="gatewayCommissioningGwNetwork"
              class="configuration-btn"
            >
              <a target="_blank" data-at-go-to-configuration-page href="http://vitoconnect.gateway">
                {{ '+GATEWAY_COMMISSIONING.CONNECT_GATEWAY.GO_TO_BUTTON' | translate }}
              </a>
            </button>
          </div>
          <div class="instruction-option flex flex-col gap-[16px] justify-start items-start">
            <div class="order">2.2</div>
            <div>
              {{ '+GATEWAY_COMMISSIONING_REDESIGN.WIFI_INSTRUCTIONS_OPTION2' | translate }}
            </div>
            <img src="assets/img/gateway-commissioning/gateway-1-arrow.jpg" />
          </div>
          <div class="instruction-option flex flex-col gap-[16px] justify-start items-start">
            <div class="order">2.3</div>
            <div>
              {{ '+GATEWAY_COMMISSIONING_REDESIGN.WIFI_INSTRUCTIONS_OPTION3' | translate }}
            </div>
            <img src="assets/img/gateway-commissioning/gateway-2-arrow.jpg" />
          </div>
        </div>
      </div>
    </app-feature-list-container>
  </div>

  <div class="steps-wrapper flex flex-col gap-[24px] xs:gap-[16px] flex-1">
    <div class="flex flex-col md:flex-row gap-[24px] xs:gap-[16px]">
      <app-edit-commissioning-step
        class="flex-1"
        [title]="'+GATEWAY_COMMISSIONING.COMMISSIONING_STEP_SELECTION.TITLE'"
        [description]="'+GATEWAY_COMMISSIONING.COMMISSIONING_STEP_SELECTION.COMPLETED'"
        [showEditButton]="true"
        [displayConfirmDialog]="true"
        (previousStep)="previousStepClicked()"
      ></app-edit-commissioning-step>
      <app-edit-commissioning-step
        class="flex-1"
        [title]="'+GATEWAY_COMMISSIONING.COMMISSIONING_STEP_VALIDATION.TITLE'"
        [description]="'+GATEWAY_COMMISSIONING.COMMISSIONING_STEP.CONTINUE_NEXT_STEP'"
      ></app-edit-commissioning-step>
    </div>
    <button
      class="next-step-btn flex-1"
      gtm="onNextStep"
      gtmCategory="gatewayCommissioningGwNetwork"
      mat-raised-button
      data-at-next-button
      color="primary"
      (click)="nextStepClicked()"
    >
      <span>{{ 'GENERAL.BUTTON.NEXT_STEP' | translate }}</span>
      <mat-icon>arrow_forward</mat-icon>
    </button>
  </div>
</div>
